<template xmlns="http://www.w3.org/1999/html">
  <div style="width: 100vw;height: 100vh;display: flex;justify-content: center;align-items: center;">
    <div id="background" class="bg">

      <img src="/static/images/qh/top-bg.png" alt="" style="width: 100%;position: absolute;top:0vh" />
      <img src="/static/images/qh/pay3m.png" alt="" style="width: 65%;position: absolute;top:3vh" />
      <img src="/static/images/qh/banner.png" alt="" style="width: 90%;position: absolute;top:11vh" />

      <div v-if="authCode != undefined"
        style="width: 90%;height: 13vh;box-shadow: 0 0 3px gray;background-color: white;border-radius: 13px;position: absolute;top:30vh;display: flex;justify-content: center;align-items: center;">
        <div style="width: 80%;height: 100%;display: flex;align-items: center;">
          <span v-if="antiTrue" class="product_title">商品名称：<span class="product">{{ productName }}</span></span>

        </div>
      </div>

      <div v-if="authCode != undefined" style="width: 87%;height: 16vh;
      position: absolute;top:45vh;display: flex;flex-direction: column;justify-content: center;align-items: center;">
        <img src="/static/images/qh/product.png"
          style="width: 100%;height: 16vh;position: absolute;top: 0;z-index: 1;" />
        <img src="/static/images/qh/anticode.png" alt="" style="width: 40%;position: absolute;top: 3vh;z-index: 2;" />
        <!--  -->
        <span class="antiCode">{{ antiCode }}</span>
        <span v-if="antiTrue" class="queryTitle">您所查询的产品为官方正品，请放心使用</span>
        <span v-if="antiTrue" class="queryContent">首次查询时间为{{ firstQueryDate }}</span>
        <span v-if="!antiTrue" class="queryTitle">您查询的数码不存在</span>
        <span v-if="!antiTrue" class="queryContent">谨防假冒，请核对后重新查询！</span>
      </div>


      <!-- v-if="antiTrue && authCode!=undefined" -->
      <div v-if="authCode != undefined && resultShow"
        style="width: 100%;height: 34vh;position: absolute;top:61vh;display: flex;flex-direction: column;justify-content: center;align-items: center;">
        <img src="/static/images/qh/win.png" style="width: 100%;height: 34vh;position: absolute;top: 0;z-index: 1;" />

        <span v-if="antiTrue && isNewJoin" class="gx">恭喜您获取积分</span>
        <span v-if="antiTrue && isNewJoin" class="jf">{{ score }}<span class="jftext">积分</span></span>

        <span v-if="!isNewJoin || !antiTrue" class="baoqian">抱歉</span>
        <span v-if="!isNewJoin && antiTrue" class="jfTip">积分已被领取</span>
        <span v-if="digitNodFound" class="jfTip">数码不存在</span>

        <wx-open-launch-weapp id="launch-btn" style="z-index: 2;position: relative;" :appid="miniAppId"
          :username="miniAppOriginalId" :path="miniAppPage">
          <script type="text/wxtag-template">
          <img src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/jfbutton.png" alt="" style="width: 180px;height: 60px;" />
                                    </script>
        </wx-open-launch-weapp>

      </div>



      <div v-if="isSnapUser == '1'"
        style="width: 100vw;height: 34vh;position: absolute;top:61vh;display: flex;flex-direction: column;justify-content: center;align-items: center;">
        <img src="/static/images/qh/win.png" style="width: 100vw;height: 34vh;position: absolute;top: 0;z-index: 1;" />


        <span v-if="!isNewJoin && antiTrue"
          style="color: red;font-weight: bold;width:60vw;margin-left: 10vw;font-size: 4.2vw;text-shadow: 0 0 3px gray;z-index: 2;">请点击底部"使用完整服务"</span>
        <span v-if="!isNewJoin && antiTrue"
          style="color: red;font-weight: bold;width:60vw;margin-left: 10vw;font-size: 4.2vw;text-shadow: 0 0 3px gray;z-index: 2;">授权用户信息，用于发放奖励</span>
      </div>

      <div class="rule" @click="openPopup">活动规则
      </div>


      <div v-show="isShow">
        <div id="fixedBg"></div>
        <p class="loading_p" id="loadP">
          <img src="/static/images/loadding.gif" />
        </p>
      </div>


      <!--活动规则开始-->
      <div v-if="showRule" style="z-index: 3;width:100%;height:100%">
        <div id="activityRule" class="modal" @click="closePopup()"></div>
        <div class="modal-content">
          <div
            style="width: 90%;position: absolute;position: absolute;top: 9%;text-align: center;display: flex;flex-direction: column;align-items: center;color: rgb(49,32,130);">
            <span class="ruletext">规则说明</span>
            <div
             class="ruleinfo">
              <div style="display: flex;text-align: left;">
                <span style="margin-right: 3px;">1.</span>正品商品贴有防伪标签，用户拿到商品后扫描防伪码查询商品真伪
              </div>
              <div style="display: flex;">
                <span style="margin-right: 3px;">2.</span>首次扫码查询可获得商品对应积分，点击积分兑换，进入小程序后即显示在个人账户中，积分可用于兑换精美商品、抽奖等；
              </div>
              <div style="display: flex;">
                <span style="margin-right: 3px;">3.</span>积分兑换仅首次扫码获得，二次扫码仅可查询商品真伪；
              </div>
              <div style="display: flex;">
                <span style="margin-right: 3px;">4.</span>最终活动解释权归本公司所有。
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--活动规则结束-->
    </div>
  </div>
</template>


<style scoped src="../../assets/css/index.css"></style>

<style scoped src="../../assets/css/style.css"></style>

<style scoped>
@media (max-width: 600px) {
  .bg {
    width: 100vw;
    position: fixed;
    background: url(/static/images/qh/bg.png) no-repeat;
    background-attachment: fixed;
    background-position: bottom;
    background-size: cover;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    align-items: center;
  }

  .product_title {
    color: black;
    font-weight: bold;
    font-size: 5vw;
  }

  .product {
    color: red;
    font-weight: 400;
    font-size: 5vw;
  }


  .antiCode {
    color: red;
    font-size: 4.5vw;
    margin-top: 6vh;
    z-index: 2;
  }



  .queryTitle {
    font-size: 3vw;
    margin-top: 0.5vh;
    z-index: 2;
  }

  .queryContent {
    font-size: 3vw;
    z-index: 2;
  }

  .baoqian {
    font-size: 8vw;
    font-weight: bold;
    z-index: 2;
  }

  .jfTip {
    color: red;
    font-weight: bold;
    font-size: 8vw;
    text-shadow: 0 0 3px gray;
    z-index: 2;
  }

  .rule {
    position: absolute;
    bottom: 2vh;
    font-size: 4vw;
    text-decoration: underline;
  }


  .gx {
    font-size: 8vw;
    font-weight: bold;
    z-index: 2;
  }

  .jf {
    color: red;
    font-weight: bold;
    font-size: 13vw;
    text-shadow: 0 0 3px gray;
    z-index: 2;
  }

  .jftext {
    color: black;
    font-weight: 400;
    font-size: 7vw;
    z-index: 2;
  }


  .modal {
    position: fixed;
    /* 固定位置 */
    z-index: 1;
    /* 位于顶层 */
    left: 0;
    top: 0;
    width: 100%;
    /* 宽度全屏 */
    height: 100%;
    /* 高度全屏 */
    overflow: auto;
    background-color: rgba(116, 116, 116, 0.5);
    /* 超出内容可滚动 */
  }

  /* 模态内容 */
  .modal-content {
    overflow: auto;
    background-color: rgba(218, 225, 238, 0.95);
    margin: 25vh auto;
    /* 上下自动，左右15% */
    padding: 25px;
    border: 0px;
    width: 90%;
    height: 350px;
    text-align: center;
    z-index: 2;
    border-radius: 20px;
    position: relative;
  }


  .ruletext {
    font-size: 5vw
  }


  .ruleinfo {
    width: 100%;
    text-align: left;
    font-size: 4vw;
    line-height: 2.5;
    margin-top: 10px;
    text-indent: -10;
  }
}

/* 针对中等屏幕设备 */
@media (min-width: 601px) and (max-width: 1200px) {
 .bg {
    width: 65vw;
    position: fixed;
    background: url(/static/images/qh/bg.png) no-repeat;
    background-attachment: fixed;
    background-position: bottom;
    background-size: cover;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    align-items: center;
  }


  .product_title {
    color: black;
    font-weight: bold;
    font-size: 3vw;
  }

  .product {
    color: red;
    font-weight: 400;
    font-size: 3vw;
  }

  .antiCode {
    color: red;
    font-size: 3vw;
    margin-top: 6vh;
    z-index: 2;
  }



  .queryTitle {
    font-size: 2vw;
    margin-top: 0vh;
    z-index: 2;
  }

  .queryContent {
    font-size: 2vw;
    z-index: 2;
  }

  .baoqian {
    font-size: 5vw;
    font-weight: bold;
    z-index: 2;
  }

  .jfTip {
    color: red;
    font-weight: bold;
    font-size: 5vw;
    text-shadow: 0 0 3px gray;
    z-index: 2;
  }

  .rule {
    position: absolute;
    bottom: 2vh;
    font-size: 2.5vw;
    text-decoration: underline;
  }

  .gx {
    font-size: 5vw;
    font-weight: bold;
    z-index: 2;
  }

  .jf {
    color: red;
    font-weight: bold;
    font-size: 9vw;
    text-shadow: 0 0 3px gray;
    z-index: 2;
  }

  .jftext {
    color: black;
    font-weight: 400;
    font-size: 6vw;
    z-index: 2;
  }

  .modal {
    position: fixed;
    /* 固定位置 */
    z-index: 1;
    /* 位于顶层 */
    left: 0;
    top: 0;
    width: 100%;
    /* 宽度全屏 */
    height: 100%;
    /* 高度全屏 */
    overflow: auto;
    background-color: rgba(116, 116, 116, 0.5);
    /* 超出内容可滚动 */
  }

  /* 模态内容 */
  .modal-content {
    overflow: auto;
    background-color: rgba(218, 225, 238, 0.95);
    margin: 25vh auto;
    /* 上下自动，左右15% */
    padding: 25px;
    border: 0px;
    width: 80%;
    height: 50vh;
    text-align: center;
    z-index: 2;
    border-radius: 20px;
    position: relative;
  }


  .ruletext {
    font-size: 4vw
  }


  .ruleinfo {
    width: 100%;
    text-align: left;
    font-size: 2.3vw;
    line-height: 2.5;
    margin-top: 10px;
    text-indent: -10;
  }
}

/* 针对大屏幕设备 */
@media (min-width: 1201px) {
  .bg {
    width: 65vw;
    position: fixed;
    background: url(/static/images/qh/bg.png) no-repeat;
    background-attachment: fixed;
    background-position: bottom;
    background-size: cover;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    align-items: center;
  }


  .product_title {
    color: black;
    font-weight: bold;
    font-size: 3vw;
  }

  .product {
    color: red;
    font-weight: 400;
    font-size: 3vw;
  }

  .antiCode {
    color: red;
    font-size: 3vw;
    margin-top: 6vh;
    z-index: 2;
  }



  .queryTitle {
    font-size: 2vw;
    margin-top: 0vh;
    z-index: 2;
  }

  .queryContent {
    font-size: 2vw;
    z-index: 2;
  }

  .baoqian {
    font-size: 5vw;
    font-weight: bold;
    z-index: 2;
  }

  .jfTip {
    color: red;
    font-weight: bold;
    font-size: 5vw;
    text-shadow: 0 0 3px gray;
    z-index: 2;
  }

  .rule {
    position: absolute;
    bottom: 2vh;
    font-size: 2.5vw;
    text-decoration: underline;
  }

  .gx {
    font-size: 5vw;
    font-weight: bold;
    z-index: 2;
  }

  .jf {
    color: red;
    font-weight: bold;
    font-size: 9vw;
    text-shadow: 0 0 3px gray;
    z-index: 2;
  }

  .jftext {
    color: black;
    font-weight: 400;
    font-size: 6vw;
    z-index: 2;
  }

  .modal {
    position: fixed;
    /* 固定位置 */
    z-index: 1;
    /* 位于顶层 */
    left: 0;
    top: 0;
    width: 100%;
    /* 宽度全屏 */
    height: 100%;
    /* 高度全屏 */
    overflow: auto;
    background-color: rgba(116, 116, 116, 0.5);
    /* 超出内容可滚动 */
  }

  /* 模态内容 */
  .modal-content {
    overflow: auto;
    background-color: rgba(218, 225, 238, 0.95);
    margin: 25vh auto;
    /* 上下自动，左右15% */
    padding: 25px;
    border: 0px;
    width: 80%;
    height: 50vh;
    text-align: center;
    z-index: 2;
    border-radius: 20px;
    position: relative;
  }


  .ruletext {
    font-size: 4vw
  }


  .ruleinfo {
    width: 100%;
    text-align: left;
    font-size: 2.3vw;
    line-height: 2.5;
    margin-top: 10px;
    text-indent: -10;
  }
}
</style>
<script>
import { getAntiResult, getScoreConfig, getTemplate, getWechatAuth, registerByOpenId, joinActivity, getJSSDK, getInfoByCode } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      isShow: false,
      authCode: "",
      antiTrue: false,
      antiFalseMessage: "",
      firstQueryDate: "",
      deptId: 0,
      activityId: 0,
      shopUrl: "",
      miniAppId: "",
      miniAppOriginalId: "",
      miniAppPage: "",
      userToken: "",
      isNewJoin: false,
      resultShow: false,
      score: 0,
      showRule: false,
      productName: "",
      digitNodFound: false,
      isSnapUser: ""
    }
  },
  methods: {
    async getCodeInfo() {
      var res = await getInfoByCode(this.antiCode)
      this.productName = res.data.data.productName
    },
    getAuth() {
      const url = window.location.href.split('#')[0];
      sessionStorage.setItem("wechatAuth", true);
      getWechatAuth(url, "wx9226bf7d87cb47e5", 1).then(res => {
        const data = res.data;
        window.location.href = data;
      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    },
    async getResult() {
      this.isShow = true
      const params = this.$route.query
      const code = params.c
      this.authCode = params.wyAuthCode
      this.isSnapUser = params.isSnapshotUser

      if (this.authCode == null || this.authCode == "" || this.authCode == undefined) {
        this.getAuth()
      }
      this.antiCode = code.substring(0, 16);
      var res = await getAntiResult(code);
      const data = res.data;
      this.isShow = false
      if (data == null || data.code == "500") {
        this.antiFalseMessage = "防伪查询失败,请联系管理员"
        this.antiTrue = false
      } else if (data.code == "300106") {
        this.antiFalseMessage = "数码不存在，谨防假冒"
        this.antiTrue = false
        this.digitNodFound = true
        this.resultShow = true
      } else {
        const year = data.data.firstQueryTime.substring(0, 4);
        const month = data.data.firstQueryTime.substring(5, 7);
        const day = data.data.firstQueryTime.substring(8, 10);
        this.firstQueryDate = year + "年" + month + "月" + day + "日";
        console.log(this.firstQueryDate);
        this.antiTrue = true
        this.deptId = data.data.deptId
        this.getCodeInfo()
        if (this.isSnapUser != "1") {
          this.joinActivity()
        }
      }

    },
    async getTemplate() {
      var res = await getTemplate(this.deptId)

      if (res != null && res.data.data != null) {
        this.activityId = res.data.data.activityId;
      }
    },
    openPopup() {
      this.showRule = true
    },
    closePopup() {
      this.showRule = false
    },
    async getScoreConfig() {
      var res = await getScoreConfig(this.deptId);
      if (res != null && res.data.data != null) {
        this.shopUrl = res.data.data.shopUrl
        const data = this.shopUrl.split('|')
        this.miniAppId = data[0]
        this.miniAppOriginalId = data[1]
        this.miniAppPage = data[2]
      }

    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wx9226bf7d87cb47e5").then(res => {
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });

      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    },
    async joinActivity() {
      await this.getScoreConfig()
      await this.getTemplate();

      if (this.activityId > 0) {
        if (this.authCode == undefined || this.authCode == "" || this.authCode == null) {
          this.getAuth()
        } else {
          const res = await registerByOpenId("138584550830", this.authCode);
          if (res != null && res.data.data != null) {
            this.userToken = res.data.data.token;
            var data = {
              code: this.antiCode,
              activityId: this.activityId,
              authCode: this.authCode,
              userToken: this.userToken
            }
            const ret = await joinActivity(data);
            if (ret.data.code == "200") {
              this.isNewJoin = true
              this.score = ret.data.data.giftValue
              this.resultShow = true
            } else if (ret.data.code == "500001") {
              this.isNewJoin = false
              this.resultShow = true
            } else {
              alert("参与营销活动失败")
            }
            sessionStorage.removeItem("wechatAuth");
          }

        }
      }


    }
  },
  mounted: function () {
    this.getWxJs()
    this.getResult()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/QiHan/Index.vue